import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title = 'Xtreme Roofing & Construction | Custom Outdoor Living Spaces',
  description = 'DFW\'s premier outdoor living specialists. Expert craftsmanship in pergolas, outdoor kitchens, retaining walls, and custom concrete solutions.',
  image = '/xtreme.png',
  schema = null
}) => {
  const location = useLocation();
  const canonicalUrl = `https://xtremeroofingandconstruction.net${location.pathname}`;

  // Default schema for local business
  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": "Xtreme Roofing & Construction",
    "image": "https://xtremeroofingandconstruction.net/xtreme.png",
    "description": description,
    "url": "https://xtremeroofingandconstruction.net",
    "telephone": "+1-682-719-2877",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Dallas-Fort Worth",
      "addressRegion": "TX",
      "addressCountry": "US"
    },
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "32.7767",  // DFW central coordinates
        "longitude": "-96.7970"
      },
      "geoRadius": "80000"  // Increased radius to cover DFW metroplex
    },
    "priceRange": "$$",
    "sameAs": [
      "https://www.facebook.com/Xtremeroofingandconstructions"
    ],
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "opens": "07:00",
      "closes": "19:00"
    },
    "paymentAccepted": ["Cash", "Credit Card", "Check"],
    "keywords": "outdoor kitchen, pergola, retaining wall, concrete patio, outdoor living space, custom pergola, DFW contractor, Dallas-Fort Worth"
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Additional Meta Tags */}
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Xtreme Roofing & Construction" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="HandheldFriendly" content="true" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />

      {/* Theme Colors */}
      <meta name="theme-color" content="#FF6B00" />
      <meta name="msapplication-TileColor" content="#FF6B00" />
      <meta name="msapplication-navbutton-color" content="#FF6B00" />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Alternate Languages */}
      <link rel="alternate" hrefLang="en" href={canonicalUrl} />
      
      {/* Favicons */}
      <link rel="icon" href="/xtreme.png" />
      <link rel="apple-touch-icon" href="/xtreme.png" />
      <link rel="manifest" href="/manifest.json" />

      {/* Structured Data / Schema.org */}
      <script type="application/ld+json">
        {JSON.stringify(schema || defaultSchema)}
      </script>

      {/* DNS Prefetch */}
      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="dns-prefetch" href="//www.google-analytics.com" />
    </Helmet>
  );
};

export default SEO; 